const BOTS = [
  {
    id: "long",
    name: "Xenoarc-Long Bot",
    description: "Proven investment strategy that minimizes the impact of market volatility by spreading out your purchases over time.",
    direction: "Long",
  },
  {
    id: "short",
    name: "Xenoarc-Short Bot",
    description: "Proven investment strategy that minimizes the impact of market volatility by spreading out your purchases over time.",
    direction: "Short",
  },
  {
    id: "ls",
    name: "Xenoarc-Long and Short Bot",
    description: "Proven investment strategy that minimizes the impact of market volatility by spreading out your purchases over time.",
    direction: "LS",
  },
];

function BotCard({ bot, onActivate, onDetail }) {
  return (
    <div className="border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between gap-2">
        <span className="text-sm font-bold text-[#1C1C1C]">{bot.name}</span>
        <span className="text-[10px] font-normal bg-[#1C1C1C] text-white px-2 py-0.5 rounded-full shrink-0">
          BETA<span className="desktop:hidden"> VER</span>
        </span>
      </div>
      <p className="text-xs text-[#7B7B7B] leading-relaxed">{bot.description}</p>
      <div className="flex items-center gap-3">
        <button
          onClick={() => onActivate(bot.direction)}
          className="text-sm font-semibold text-[#302571] bg-[#ECEAF8] rounded-lg px-3 py-2 hover:bg-[#e1dcef] transition-colors"
        >
          Activate
        </button>
        <button
          onClick={() => onDetail?.(bot)}
          className="text-sm font-semibold text-[#333333] hover:text-[#1C1C1C] transition-colors"
        >
          Learn more
        </button>
      </div>
    </div>
  );
}

export default function BotSelectionSection({ onActivate, onDetail }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6">
      <h2 className="text-base font-semibold text-[#21272A] mb-4">Bot Selection</h2>
      {/* stacked list on mobile/tablet, 2-col grid only at desktop */}
      <div className="grid grid-cols-1 desktop:grid-cols-2 gap-4">
        {BOTS.map((bot) => (
          <BotCard
            key={bot.id}
            bot={bot}
            onActivate={onActivate}
            onDetail={onDetail}
          />
        ))}
      </div>
    </div>
  );
}
